/**
 * ACT2-1108: whether the chat home shows the setup panel.
 *
 * It shows for an owner or admin until every counted step is done, unless they hid it. When the last
 * step is done while the panel is on screen, it stays for the rest of the visit, so the person sees the
 * step tick and the "You're set up" line instead of the panel vanishing under them.
 */
import { useState } from 'react';

import type { SetupProgress } from '@/_shared/hooks/useSetupProgress';

export function useSetupPanelVisible(progress: SetupProgress): boolean {
  const [sawIncomplete, setSawIncomplete] = useState(false);
  if (progress.status !== null && !progress.complete && !sawIncomplete) setSawIncomplete(true);
  if (progress.status === null || progress.prefs.hidden) return false;
  return !progress.complete || sawIncomplete;
}
